/**
 * Creates a Date object in local time from a YYYY-MM-DD formatted string.
 * @param dateStr - Date string in 'YYYY-MM-DD' format
 * @returns Date object at midnight local time
 */
export function parseLocalDate(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
// src/utils/dateUtils.ts

/**
 * Returns a Date object representing the first day of the next month at midnight (local time)
 */
export function getEndOfMonth(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}
